// extracted by mini-css-extract-plugin
export default {"label":"NumberInput_label__RbACQ","numberInput":"NumberInput_numberInput__oVGO5","input":"NumberInput_input__p0Fu5"};